import { render } from "./PageForm.vue?vue&type=template&id=699c3044"
import script from "./PageForm.vue?vue&type=script&lang=js"
export * from "./PageForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/PageForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "699c3044"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('699c3044', __exports__)) {
    api.reload('699c3044', __exports__)
  }
  
  module.hot.accept("./PageForm.vue?vue&type=template&id=699c3044", () => {
    api.rerender('699c3044', render)
  })

}


export default __exports__